import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { br.com.logicalside.proposes.pages.HomePage() }
        ctx.router.register("/privacy-policy") {
                br.com.logicalside.proposes.pages.PrivacyPolicyPage() }
        ctx.router.register("/terms") { br.com.logicalside.proposes.pages.TermsPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline1-text", br.com.logicalside.proposes.Headline1TextStyle)
        ctx.theme.registerStyle("headline2-text", br.com.logicalside.proposes.Headline2TextStyle)
        ctx.theme.registerStyle("headline3-text", br.com.logicalside.proposes.Headline3TextStyle)
        ctx.theme.registerStyle("headline4-text", br.com.logicalside.proposes.Headline4TextStyle)
        ctx.theme.registerStyle("title-text", br.com.logicalside.proposes.TitleTextStyle)
        ctx.theme.registerStyle("body-text", br.com.logicalside.proposes.BodyTextStyle)
        ctx.theme.registerStyle("label-text", br.com.logicalside.proposes.LabelTextStyle)
        ctx.theme.registerStyle("inner-container",
                br.com.logicalside.proposes.components.layouts.InnerContainerStyle)
        ctx.theme.registerStyle("inner-content",
                br.com.logicalside.proposes.components.layouts.InnerContentStyle)
        ctx.theme.registerStyle("markdown",
                br.com.logicalside.proposes.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content",
                br.com.logicalside.proposes.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("about-container",
                br.com.logicalside.proposes.components.sections.AboutContainerStyle)
        ctx.theme.registerStyle("about-content",
                br.com.logicalside.proposes.components.sections.AboutContentStyle)
        ctx.theme.registerStyle("about-title",
                br.com.logicalside.proposes.components.sections.AboutTitleStyle)
        ctx.theme.registerStyle("about-description",
                br.com.logicalside.proposes.components.sections.AboutDescriptionStyle)
        ctx.theme.registerStyle("about-image",
                br.com.logicalside.proposes.components.sections.AboutImageStyle)
        ctx.theme.registerStyle("contact-container",
                br.com.logicalside.proposes.components.sections.ContactContainerStyle)
        ctx.theme.registerStyle("contact-content",
                br.com.logicalside.proposes.components.sections.ContactContentStyle)
        ctx.theme.registerStyle("contact-title",
                br.com.logicalside.proposes.components.sections.ContactTitleStyle)
        ctx.theme.registerStyle("contact-description",
                br.com.logicalside.proposes.components.sections.ContactDescriptionStyle)
        ctx.theme.registerStyle("contact-image",
                br.com.logicalside.proposes.components.sections.ContactImageStyle)
        ctx.theme.registerStyle("download-container",
                br.com.logicalside.proposes.components.sections.DownloadContainerStyle)
        ctx.theme.registerStyle("download-title",
                br.com.logicalside.proposes.components.sections.DownloadTitleStyle)
        ctx.theme.registerStyle("download-badge",
                br.com.logicalside.proposes.components.sections.DownloadBadgeStyle)
        ctx.theme.registerStyle("footer",
                br.com.logicalside.proposes.components.sections.FooterStyle)
        ctx.theme.registerStyle("hero-container",
                br.com.logicalside.proposes.components.sections.HeroContainerStyle)
        ctx.theme.registerStyle("hero-overlay",
                br.com.logicalside.proposes.components.sections.HeroOverlayStyle)
        ctx.theme.registerStyle("hero-title",
                br.com.logicalside.proposes.components.sections.HeroTitleStyle)
        ctx.theme.registerStyle("hero-description",
                br.com.logicalside.proposes.components.sections.HeroDescriptionStyle)
        ctx.theme.registerStyle("nav-header",
                br.com.logicalside.proposes.components.sections.NavHeaderStyle)
        ctx.theme.registerVariant("-circle", br.com.logicalside.proposes.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", br.com.logicalside.proposes.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in",
                br.com.logicalside.proposes.components.sections.SideMenuSlideInAnim)
        br.com.logicalside.proposes.initColorMode(ctx)
        br.com.logicalside.proposes.initSiteStyles(ctx)
        br.com.logicalside.proposes.initTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "ProPoses"))
    renderComposable(rootElementId = "root") {
        br.com.logicalside.proposes.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
